import { RostersState } from './state';
import { rostersInitialState } from './initial-state';
import { RostersActions } from './action-creators';
import * as actions from './actions';

export const rostersReducer = (
  state: RostersState = rostersInitialState,
  action: RostersActions
): RostersState => {
  switch (action.type) {
    case actions.GET_ROSTERS_SUCCESS: {
      return {
        ...state,
        loaded: true,
        list: action.list,
      };
    }

    case actions.UPDATE_ROSTER_SUCCESS: {
      return {
        ...state,
        list: state.list.map((r) => {
          if (r.id === action.roster.id) {
            return {
              ...r,
              ...action.roster,
            };
          }

          return r;
        }),
      };
    }

    case actions.DELETE_ROSTER_SUCCESS: {
      return {
        ...state,
        list: state.list.filter((i) => i.id !== action.rosterId),
      };
    }

    case actions.ATTACH_TO_ROSTER_SUCCESS: {
      const artistList = state.artists[action.relation.id] || [];

      return {
        ...state,
        artists: {
          ...state.artists,
          [action.relation.id]: artistList.concat([action.relation]),
        },
      };
    }

    case actions.REMOVE_FROM_ROSTER: {
      const artistList = state.artists[action.relation.id] || [];

      return {
        ...state,
        artists: {
          ...state.artists,
          [action.relation.id]: artistList.filter(
            (r) => r.artistId !== action.relation.artistId
          ),
        },
      };
    }

    case actions.LIST_ROSTER_ARTIST_SUCCESS: {
      return {
        ...state,
        artists: {
          ...state.artists,
          [action.rosterId]: action.list,
        },
      };
    }

    case actions.CREATE_ROSTER_SUCCESS: {
      return {
        ...state,
        list: state.list.concat([action.roster]),
      };
    }

    case actions.LIST_ROSTER_OPERATORS_SUCCESS: {
      return {
        ...state,
        operators: {
          ...state.operators,
          [action.rosterId]: action.list,
        },
      };
    }

    case actions.CREATE_ROSTER_OPERATOR_SUCCESS: {
      return {
        ...state,
        operators: {
          ...state.operators,
          [action.rosterId]: state.operators[action.rosterId].concat(
            action.operator
          ),
        },
      };
    }

    case actions.REMOVE_OPERATOR_FROM_ROSTER: {
      const operatorsList = state.operators[action.rosterId] || [];

      return {
        ...state,
        operators: {
          ...state.operators,
          [action.rosterId]: operatorsList.filter(
            (r) => r.userId !== action.operatorId
          ),
        },
      };
    }

    default:
      return state;
  }
};
